import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFacebookIcon from './svgs/FacebookIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var facebookIcon = (props => useIcon(SvgFacebookIcon, SvgFacebookIcon, props));

export { facebookIcon as default };
